import { EProblemReportStatus } from '@constants';
import { IReport } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { Flex, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { formatRelativeDate } from '../../../../utils/formatRelativeDate';
import { getProblemReportWarningConfig } from '../../../../utils/getProblemReportWarningConfig';

import { Icon } from '@/components/Icon';

type Props = {
  reports: IReport[];
};

export const LastReportDateCell: React.FC<Props> = ({ reports }) => {
  const { t } = useTranslation(['DefaultTranslations', 'ProblemReportsTranslations']);

  const lastReport = reports.reduce((latest, report) =>
    new Date(report.createdAt) > new Date(latest.createdAt) ? report : latest
  );

  const daysSinceLastReport = dateProvider.diffCalendarDays(
    new Date(lastReport.createdAt),
    new Date()
  );

  const hasNotReviewedReports = reports.some(
    report => report.status === EProblemReportStatus.NOT_REVIEWED
  );

  const warningConfig =
    hasNotReviewedReports && getProblemReportWarningConfig(daysSinceLastReport, t);

  return (
    <Flex align="center" gap={4}>
      <span>{formatRelativeDate(lastReport.createdAt, t)}</span>
      {warningConfig && (
        <Tooltip title={warningConfig.tooltip}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <Icon i="WarningFilled" style={{ color: warningConfig.color }} />
          </span>
        </Tooltip>
      )}
    </Flex>
  );
};
